import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { useState } from 'react';

export default function KillConfirmDialog({
  taskIds,
  onConfirm,
  onClose,
}: {
  taskIds: string[];
  onConfirm: () => Promise<unknown>;
  onClose: () => void;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const count = taskIds.length;
  const label = count === 1 ? `task ${taskIds[0]}` : `${count} tasks`;

  return (
    <Dialog open onClose={busy ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Kill {label}?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Execution is terminated on the worker and the {count === 1 ? 'task ends' : 'tasks end'} FAILED with the error
          &quot;Killed by user request&quot;. Progress is lost. A killed task can be reset to run it again.
        </DialogContentText>
        {error && (
          <DialogContentText color="error" sx={{ mt: 2 }}>
            {error}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          disabled={busy}
          onClick={() => {
            setBusy(true);
            setError(null);
            onConfirm().then(onClose, () => {
              setError('Kill failed');
              setBusy(false);
            });
          }}
        >
          {busy && <CircularProgress size={16} sx={{ mr: 1 }} />}
          Kill {count === 1 ? 'task' : 'tasks'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
